<script setup lang="ts">
definePageMeta({
  layout: "focus",
});

const { t } = useI18n({
  useScope: "local",
});
</script>

<template>
  <Card class="w-[420px]">
    <CardHeader>
      <nuxt-img class="w-full scale-75 mx-auto" src="/assets/logo.svg" alt="Logo" />
    </CardHeader>
    <CardContent class="grid gap-4 mb-4">
      <div class="text-center">
        <h3 class="text-2xl font-semibold">{{ t("title") }}</h3>
        <p class="text-muted-foreground">{{ t("description") }}</p>
      </div>
    </CardContent>
  </Card>
</template>

<i18n lang="yaml" scope="global">
en:
  title: The site does not exist
  description: Please check the URL or contact support for assistance.
</i18n>
